import { reject } from "lodash";

class PictureService {
  async readFile(file: Blob): Promise<string> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => resolve(reader.result as string);
    });
  }

  private static createImage(imageSrc: string): HTMLImageElement {
    const image = new Image();
    image.src = imageSrc;
    return image;
  }

  async getCroppedImage(
    originalFile: string,
    croppedPixels: any
  ): Promise<Blob | null> {
    const image = PictureService.createImage(originalFile);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) return null;

    canvas.width = image.width;
    canvas.height = image.height;

    ctx.drawImage(image, 0, 0);

    const data = ctx.getImageData(
      croppedPixels.x,
      croppedPixels.y,
      croppedPixels.width,
      croppedPixels.height
    );

    canvas.width = croppedPixels.width;
    canvas.height = croppedPixels.height;

    ctx.putImageData(data, 0, 0);

    return new Promise((resolve) => {
      canvas.toBlob((file) => {
        if (!file) return reject(null);
        resolve(file);
      }, "image/jpeg");
    });
  }
}

const _pictureService = new PictureService();

export default _pictureService;
